import PlayButton, { PlayButtonProps } from './PlayButton';

export default PlayButton;
export type { PlayButtonProps };
